import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import CategoriaDesempenioServices from "./categoriasDesempenio.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetCategoriasDesempenio = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_CATEGORIA_DESEMPENIO,
      payload: true,
    });
    dispatch({
      type: actions.GET_CATEGORIA_DESEMPENIO,
      payload: {data:[],count:0}, // agregar .data
    });
    dispatch({
      type: actions.CATEGORIA_DESEMPENIO_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.CATEGORIA_DESEMPENIO_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_CATEGORIA_DESEMPENIO,
      payload: false,
    });
  }
}

export const getCategoriasDesempenio = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_CATEGORIA_DESEMPENIO,
      payload: true,
    });
    const resp = await CategoriaDesempenioServices.getCategoriasDesempenio(filters);
    // console.clear();
    // console.log('RESPONSE => ', resp.data);
    dispatch({
      type: actions.GET_CATEGORIA_DESEMPENIO,
      payload: resp.data, // agregar .data
    });
    dispatch({
      type: actions.CATEGORIA_DESEMPENIO_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.CATEGORIA_DESEMPENIO_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_CATEGORIA_DESEMPENIO,
      payload: false,
    });
  }
}

export const saveCategoriaDesempenio = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_CATEGORIA_DESEMPENIO,
      payload: true,
    });
    const resp = await CategoriaDesempenioServices.saveCategoriaDesempenio(req);
    const { data, count } = getState().categoriaDesempenio.categoriaDesempenio;
    dispatch({
      type: actions.GET_CATEGORIA_DESEMPENIO,
      payload: {
        count: count + 1,
        data: [...data, resp.data]
      },
    });
    dispatch({
      type: actions.FORM_CATEGORIA_DESEMPENIO_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_CATEGORIA_DESEMPENIO_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_CATEGORIA_DESEMPENIO,
      payload: false,
    });
  }
};

export const editCategoriaDesempenio = (req, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_CATEGORIA_DESEMPENIO,
      payload: true,
    });
    const resp = await CategoriaDesempenioServices.editCategoriaDesempenio(req.id, req);
    const { data, count } = getState().categoriaDesempenio.categoriaDesempenio;
    let _data = data.slice();
    _data[index] = resp.data;
    dispatch({
      type: actions.GET_CATEGORIA_DESEMPENIO,
      payload: {
        data: _data,
        count: count,
      },
    });
    dispatch({
      type: actions.FORM_CATEGORIA_DESEMPENIO_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_CATEGORIA_DESEMPENIO_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_CATEGORIA_DESEMPENIO,
      payload: false,
    });
  }
}

export const deleteCategoriaDesempenio = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_CATEGORIA_DESEMPENIO,
      payload: true,
    });
    await CategoriaDesempenioServices.deleteCategoriaDesempenio(id);
    const { data, count } = getState().categoriaDesempenio.categoriaDesempenio;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_CATEGORIA_DESEMPENIO,
      payload: {
        data: _data,
        count: count - 1
      },
    });
    dispatch({
      type: actions.CATEGORIA_DESEMPENIO_FALLA,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data[0]){
              message = ex.response.data[0];
            }else{
              message = ex.response.data.mensaje;
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADER_CATEGORIA_DESEMPENIO,
      payload: false,
    });
  }
}